import {
  selectAttachmentReplacementNameRule,
  selectChangeMessageForFile,
} from '@UI/aside/asideFileSelector/asideFileSelectors';
import { selectMusicNode } from '@newStore/documentUI/transformContent/musicSelectors';
import { type BuildingBlockNodeConfig, RequiredType } from '@nodeTypeConfig/configTypes';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const MUSIC: BuildingBlockNodeConfig = {
  nodeSelector: selectMusicNode,
  information: {
    single: 'Muziek',
    plural: 'Muziek',
    ribonIcon: require('../../../../img/buildingBlocks/MUSIC.svg'),
  },
  buildingBlocks: [],
  edit: [
    descriptionComponent,
    {
      component: 'file',
      reactComponent: 'AsideFile',
      label: 'Bestand',
      definiteArticle: true,
      property: 'attachments',
      asideChangeMessageSelector: selectChangeMessageForFile,
      validations: [selectAttachmentReplacementNameRule],
      required: RequiredType.ERROR,
      options: {
        validExtensions: '.mp3',
        type: 'ATTACHMENT',
      },
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: true,
  },
};

export default MUSIC;
